// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6742) return "static/chunks/281c3f4d-9f39d047a8cb31b3.js";
	if (chunkId === 6941) return "static/chunks/6941-144a3fc29087ed80.js";
	if (chunkId === 9923) return "static/chunks/8e095c31-89cc479daa8d21c2.js";
	if (chunkId === 8009) return "static/chunks/8009-d4d1c58cff11c55c.js";
	if (chunkId === 9357) return "static/chunks/9357-28c3729f70d1c4c2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"521":"b766ef233d6cc968","536":"56b4042c679aafd0","2004":"9f0ebc65a43418cc","8215":"2bcf9701d79dc9b3","8964":"e7c8a5a3686976bd"}[chunkId] + ".js";
};